import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {InputDate} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {SelectOption} from '../../../../../../models/utility.model'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {useBed} from '../../../../hooks/useBed'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useModules} from '../../../../hooks/useModules'
import {useRooms} from '../../../../hooks/useRooms'
import {ConfirmChangeRoomModel} from '../../../../models/change-rooms.model'
import {createChangeRoomService} from '../../../../services/change-rooms.service'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  bookingToEdit: any
  getBookings: () => void
  camp?: string
}

const ModalConfirmChangeRoom: FC<Props> = ({show, setShow, bookingToEdit, getBookings, camp}) => {
  const handleClose = () => {
    setShow(false)
    resetForm()
  }

  const {getCamps, getUsers} = useCentralServices()
  const {getModules} = useModules()
  const {getRooms} = useRooms()
  const {getBeds} = useBed()

  const [, setUsers] = useState<SelectOption[]>([])
  const [camps, setCamps] = useState<SelectOption[]>([])
  const [modules, setModules] = useState<SelectOption[]>([])
  const [rooms, setRooms] = useState<SelectOption[]>([])
  const [beds, setBeds] = useState<SelectOption[]>([])
  const [rooms2, setRooms2] = useState<SelectOption[]>([])
  const [beds2, setBeds2] = useState<SelectOption[]>([])

  const confirmChangeRoomSchema = Yup.object().shape({
    CampamentoId: Yup.string().required('Campamento es requerido'),
    ModuloId: Yup.string().required('Modulo es requerido'),
    CurrentRoomId: Yup.string().required('Habitacion Anterior es requerido'),
    NewRoomId: Yup.string().required('Nueva Habitacion es requerido'),
    CurrentBedId: Yup.string().required('Cama Anterior es requerido'),
    CamaId_Nuevo: Yup.string().required('Nueva Cama es requerido'),
    ClienteId: Yup.string().required('Interlocutor es requerido'),
    FechaAprobacion: Yup.string().required('Fecha Aprobacion es requerido'),
    Observacion: Yup.string().required('Observacion es requerido'),
  })

  const {
    register,
    setValue,
    handleSubmit,
    control,
    // watch,
    setError,
    formState: {errors},
  } = useForm<ConfirmChangeRoomModel>({
    resolver: yupResolver(confirmChangeRoomSchema),
  })

  const getCampsFn = async () => {
    const data = await getCamps({isCombo: true}, 1)
    setCamps(data)
  }

  const getModulesFn = async () => {
    const data = await getModules({CampamentoId: camp})
    setModules(data)
  }

  const getRoomsFn = async () => {
    const data = await getRooms({})
    setRooms(data)
  }

  const getBedsFn = async () => {
    const data = await getBeds({})
    setBeds(data)
  }

  const getNewRoomsFn = async (moduleId: string) => {
    const data = await getRooms({ModuloId: moduleId})
    setRooms2(data)
  }

  const getNewBedsFn = async (roomId: string) => {
    const data = await getBeds({HabitacionId: roomId})
    setBeds2(data)
  }

  const getUserFn = async () => {
    const data = await getUsers({isCombo: true}, 1)
    setUsers(data)
  }

  const handleModuleChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ModuloId', value)
    setRooms2([])
    setBeds2([])
    getNewRoomsFn(value)
    setValue('NewRoomId', '')
    setValue('CamaId_Nuevo', '')
    setError('ModuloId', {})
  }

  const handleRoomChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('NewRoomId', value)
    setValue('CamaId_Nuevo', '')
    getNewBedsFn(value)
    setBeds2([])
    setError('NewRoomId', {})
  }

  useEffect(() => {
    getUserFn()
    getCampsFn()
    getModulesFn()
    getRoomsFn()
    getBedsFn()
    setValue('CampamentoId', camp)
    setValue('CurrentBedId', bookingToEdit?.CamaId)
    setValue('CurrentRoomId', bookingToEdit?.HabitacionId)
    setValue('ReservaCamaId', bookingToEdit?.ReservaCamaId)
    setValue('ClienteId', bookingToEdit?.InterlocutorNombre)
    setValue('TipoHuesped', bookingToEdit?.TipoHuespedNombre)
  }, [])

  const isRequired = bookingToEdit.TipoHuespedRequiereAprobar

  const resetForm = () => {}

  const onSubmit = async (data: ConfirmChangeRoomModel) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `La reserva tiene un estado ${bookingToEdit?.Estado}, desea continuar?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, asignar',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const {data: res} = await createChangeRoomService(data)
          if (!res.error) {
            getSnackBarToast(`Se cambio de cama con exito`, 'success')
            handleClose()
            getBookings()
            // mostrar snackbar
          } else {
            getSnackBarToast(res.message || 'Hubo un error', 'error')
          }
        } catch (error) {
          getSnackBarToast('Hubo un error', 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
      }
    })
  }

  const handleChangeDate = (e: any) => {
    setValue('FechaAprobacion', e.target.value)
    setError('FechaAprobacion', {})
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Confimar Cambio de Habitacion</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <h4>
            Reserva Nro {bookingToEdit?.CodigoReserva} - Huésped:{' '}
            {bookingToEdit?.HuespedDescripcion}
          </h4>
          <form>
            <div className='p-6'>
              <div className='d-flex'>
                <div className='col-6'>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Campamento:</label>
                    <Select
                      control={control}
                      name='CampamentoId'
                      data={camps}
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Habitacion Anterior:</label>
                    <Select
                      control={control}
                      name='CurrentRoomId'
                      data={rooms}
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Cama Anterior:</label>
                    <Select
                      control={control}
                      name='CurrentBedId'
                      data={beds}
                      errors={errors}
                      disabled
                    />
                  </div>

                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required form-label'>Interlocutor</label>
                    <div
                      className='input-group input-group-sm'
                      style={{
                        width: '97%',
                      }}
                    >
                      <input
                        type='text'
                        className='form-control w-95'
                        {...register('ClienteId')}
                        disabled
                      />
                    </div>
                  </div>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className={`${isRequired ? 'required' : ''}`}>
                      Fecha de Aprobacion:
                    </label>
                    <InputDate
                      name='FechaAprobacion'
                      register={register}
                      errors={errors}
                      onChange={handleChangeDate}
                      defaultValue={isRequired ? '' : moment().format('YYYY-MM-DD')}
                    />
                  </div>
                  <div className='mb-2 col-12'>
                    <label className='required form-label'>Observacion</label>
                    <div
                      className='input-group input-group-sm'
                      style={{
                        width: '97%',
                      }}
                    >
                      <textarea className='form-control w-95' {...register('Observacion')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Observacion?.message}
                    </p>
                  </div>
                </div>
                <div className='col-6'>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Modulo:</label>
                    <Select
                      control={control}
                      name='ModuloId'
                      data={modules}
                      errors={errors}
                      onChangeValue={handleModuleChange}
                    />
                  </div>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Nueva Habitacion:</label>
                    <Select
                      control={control}
                      name='NewRoomId'
                      data={rooms2}
                      errors={errors}
                      onChangeValue={handleRoomChange}
                    />
                  </div>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Nueva Cama:</label>
                    <Select control={control} name='CamaId_Nuevo' data={beds2} errors={errors} />
                  </div>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required form-label'>Status de Huésped</label>
                    <div
                      className='input-group input-group-sm'
                      style={{
                        width: '97%',
                      }}
                    >
                      <input
                        type='text'
                        className='form-control w-95'
                        {...register('TipoHuesped')}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='submit' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalConfirmChangeRoom}
